module.exports = __webpack_public_path__ + "static/media/icon_location.6cf4b36f.svg";